import { InjectionToken } from '@angular/core';

export const DATA_API_BASE = new InjectionToken<string>('DATA_API_BASE');
export const AUTH_API_BASE = new InjectionToken<string>('AUTH_API_BASE');
